import dayjs from "dayjs";
import { getPeriodRange } from "@/entities/report";
import type { PeriodType } from "@/entities/report";

// Resolve a period preset to a "DD.MM.YYYY — DD.MM.YYYY" label for the list
// subtitle.
export function formatComparisonPeriod(period: PeriodType): string {
  const { dateFrom, dateTo } = getPeriodRange(period);
  return `${dayjs(dateFrom).format("DD.MM.YYYY")} — ${dayjs(dateTo).format("DD.MM.YYYY")}`;
}
